import { render, staticRenderFns } from "./weighingScale.vue?vue&type=template&id=35cfd180&scoped=true&"
import script from "./weighingScale.vue?vue&type=script&lang=js&"
export * from "./weighingScale.vue?vue&type=script&lang=js&"
import style0 from "./weighingScale.vue?vue&type=style&index=0&id=35cfd180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cfd180",
  null
  
)

export default component.exports